( function () {
    'use strict';
    espresso.ecom = {};
    jQuery( function () {
        espresso.ecom.productgrid.init();
        espresso.ecom.productlist.init();
        espresso.ecom.productdetails.init();
        espresso.ecom.checkout.init();
        //e.ecom.quick.init();
        //e.ecom.multi.init();
        espresso.ecom.inpageModalCart.init();
    } );
}() );
